import React from 'react';
import Switch from 'react-switch';

type Props = {
  className?: string;
  checked: boolean;
  disabled?: boolean;
  handleClick(): void;
  id: string;
  trackingCallback?(event: string, params?: object): void;
  trackingParams?: object;
}

const ReactSwitch = (Switch as unknown as { default: typeof Switch }).default ?? Switch;

const ToggleSwitch = ({ className, checked, disabled, handleClick, id, trackingCallback, trackingParams }: Props): JSX.Element => {
  const onChange = (): void => {
    if (trackingCallback) {
      trackingCallback('clicked-button', trackingParams);
    }
    handleClick();
  }

  return (
    <ReactSwitch id={id} className={className} onChange={onChange}
      checked={checked} checkedIcon={false} disabled={disabled} uncheckedIcon={false}
      onColor='#4649DF' />
  );
}

export { ToggleSwitch };
